var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper",on:{"click":function($event){_vm.$store.state.isOpenAccountDropDown = false}}},[_c('top'),_c('menu-bar'),_c('main-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }